import React from "react"

function CardMention() {

    return (
        <div className="flex justify-center space-x-20 -mt-80 2xl:-mt-64 3xl:-mt-72 card-mention relative">
            <div className="relative">
                <div className="relative visible">

                    <iframe width="560" height="315" src="https://www.youtube.com/embed/PwcP2zUbhtg?si=zwttUKbXhrESrRgy"
                            title="YouTube video player" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            className="xl:w-[1200px] xl:h-[600px] card-mention-image inset-0 bg-black bg-opacity-20"
                            allowFullScreen></iframe>

                </div>
            </div>
        </div>
    );
}

export default CardMention;
